import { StatusCatalog } from "@interfaces/response";
import { PATHS_TOFU_V2, STATUS_CATALOG } from "@helpers/constantes";
import { normalizeUrl } from "@helpers/funciones";

/** A partir de este status (sala de espera) el onboarding queda cerrado: ya no se puede regresar. */
export const STATUS_SIN_REGRESO = STATUS_CATALOG.waiting_room.code; // CSCOF

/**
 * Pantallas posteriores a la sala de espera que, una vez que la solicitud avanzó de su status, tampoco se
 * pueden volver a abrir: aceptar la pre-oferta (CSAAO) no tiene regreso.
 */
export const STATUS_SIN_REGRESO_AL_AVANZAR: string[] = [STATUS_CATALOG.oferta.code];

/**
 * Status fuera de la secuencia (en `status_config` van después de CSCOF) desde los que sí se puede regresar: sin
 * cobertura (CSSCO) deja corregir el domicilio.
 */
export const STATUS_CON_REGRESO: string[] = [STATUS_CATALOG.sin_cobertura.code];

/**
 * Si la solicitud ya llegó a `STATUS_SIN_REGRESO` (o va más adelante en el `status_config`) y el
 * usuario intenta abrir una pantalla anterior —con el "atrás" del navegador o escribiendo la url—,
 * devuelve a dónde mandarlo: la pantalla del status actual. Si no hay que bloquear, `null`.
 *
 * Pantallas anteriores = las urls del `status_config` antes de `STATUS_SIN_REGRESO`, más crear
 * cuenta (corre antes de que exista solicitud y no tiene status), más las de
 * `STATUS_SIN_REGRESO_AL_AVANZAR` cuando la solicitud ya va más adelante que ellas.
 */
export const getRedirectAfterWaitingRoom = (
  statusConfig: StatusCatalog[],
  loanStatus: string,
  pathname: string,
): string | null => {
  if (STATUS_CON_REGRESO.includes(loanStatus)) return null;
  const lockIndex = statusConfig.findIndex((item) => item.code === STATUS_SIN_REGRESO);
  const currentIndex = statusConfig.findIndex((item) => item.code === loanStatus);
  if (lockIndex === -1 || currentIndex === -1 || currentIndex < lockIndex) return null;

  const passedOneWay = statusConfig.filter(
    (item, index) => STATUS_SIN_REGRESO_AL_AVANZAR.includes(item.code) && index < currentIndex,
  );
  const blocked = new Set([
    ...statusConfig.slice(0, lockIndex).map((item) => normalizeUrl(item.url)),
    ...passedOneWay.map((item) => normalizeUrl(item.url)),
    normalizeUrl(PATHS_TOFU_V2.crearCuenta.path),
  ]);
  if (!blocked.has(normalizeUrl(pathname))) return null;

  return normalizeUrl(statusConfig[currentIndex].url);
};
